import React from 'react';
import { Box, Tooltip } from '@mui/material';

const ActionableNoteCell = React.memo(({ 
    truncatedText, 
    isDisabled, 
    readOnly,
    onClick, 
    tooltipTitle, 
    disabledTooltipTitle,
    iconActive, 
    iconDisabled, 
    altText 
}) => {
    return (
        <Box 
            sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                width: '100%', 
                height: '100%', 
                position: 'relative', 
                cursor: isDisabled ? 'default' : 'pointer'
            }}
            onClick={(e) => {
                e.stopPropagation();
                if (onClick) onClick();
            }}
        >
            <span style={{ 
                overflow: 'hidden', 
                textOverflow: 'ellipsis', 
                whiteSpace: 'nowrap',
                display: 'block',
                width: '100%',
                paddingLeft: '5px', 
                paddingRight: '24px' 
            }}>
                {truncatedText || ""}
            </span>
            <Tooltip title={isDisabled ? (disabledTooltipTitle || "View") : tooltipTitle}>
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: '4px',
                        right: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        opacity: isDisabled ? 0.5 : 1
                    }}
                >
                    <img 
                        height="14px" 
                        src={isDisabled ? iconDisabled : iconActive} 
                        alt={altText} 
                        style={{ filter: isDisabled ? 'grayscale(100%)' : 'none' }}
                    />
                </Box>
            </Tooltip>
        </Box>
    );
});

export default ActionableNoteCell;
